import { render } from "./QuizFinancial.vue?vue&type=template&id=10b376b5"
import script from "./QuizFinancial.vue?vue&type=script&lang=js"
export * from "./QuizFinancial.vue?vue&type=script&lang=js"

import "./QuizFinancial.vue?vue&type=style&index=0&id=10b376b5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__